const SgiTableEO = function () {
    return {
        // cId: "UIprmsTable",
        isSt: true,
        chkMd: "0",
        // cluDes: "SD_TV_UI_000101",
        // cpB: 0,
        ctlH: '100%',
        ctlN: "表格",
        ctlW: '100%',
        desId: "EP_EO_UI_3008",
        // insName: "UIprms",
        // isBatch: false,
        // isBrdr: false,
        isEd: false,
        isHeaders: false,
        isPg: true,
        isPage: true,//显示翻页器
        size: "small",//表格大小，默认为小
        // isRowNo: false,
        // isSch: true,
        isTbSpt: true,
        isTtl: true,
        // pgRows: 8,
        rowSMd: "9",
        sNo: 0,
        selFirst: false,
        loading: false,//初始加载中
        // clpDrt: "top",
        // clpd: false,
        // isClp: false,
        // isClpFst: true,
        // isFill: true,
        // isHClpTl: false,
        // isLkClu: false,
        // isMsMu: false,
        // isIntSch: true,
        // isTal: true,
        // isRowexp: false,
        // isttlClp: false,
        // flx: 0,
        // iconPh: "SD_RP_IR_0001`UI`UI08",
        // smayFlag: false,
        // ttlAlg: "top",
        // ttlAlgn: "0",
        // useTim: 0,
        // visible: true
    }
}
export { SgiTableEO };
export default SgiTableEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTableEO.js